<div class="pb-4">

  <div class="container text-center min-width p-0">

    <!-- Breadcrumb -->
    <div class="row p-0 m-0">
      <div class="col-lg-12 col-md-12 col-sm-12 text-start">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb" style="margin-bottom: 0.5rem;">
            <li class="breadcrumb-item">
              <a (click)="routerLink('home')" class="text-padrao"><i class="bi bi-grid position-relative"></i> Dashboard</a>
            </li>
            <li class="breadcrumb-item">
              <a (click)="routerLink('grupos-usuarios')" class="text-padrao">Grupos</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{id}}</li>
          </ol>
        </nav>
      </div>

      <div class="col-12 text-start">
        <button type="button" class="btn btn-outline-secondary mb-2" (click)="routerLink('grupos-usuarios')" style="display: flex; justify-content: space-around;">
          <i class="bi bi-arrow-left"></i>
          Voltar
        </button>
      </div>
    </div>


    <!-- Grupo -->
    <div class="row p-0 m-0">
      <div class="row p-0 m-0">
        <div class="min-width col-lg mb-3">
          <div class="box-gen-card">
            <div class="row p-0 m-0">
              <div class="col-lg-12 reset-padding-mobile">
                <h3 class="p-0 m-0 text-cor-padrao text-start w-100">
                  Grupo Usuário - <span style="font-style: italic; font-size: 13px;">{{id}}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Grupo Dados -->
      <div class="min-width col-lg-12 pb-3">
        <div class="p-0 m-0 box-gen-card">
          <div class="row p-0 m-0">
            <!-- grupo.nome -->
            <div class="col-lg-12 reset-padding-mobile">
              <div style="display: flex;flex-direction: row;align-items: center;flex-wrap: nowrap;justify-content: space-between;margin-top: 5px;">
                <app-ag-input-field class="w-100"
                  [(ngModel)]="grupo.nome.valor"
                  [label]="grupo.nome.title"
                  [tooltip]="grupo.nome.info"
                  [value]="grupo.nome.valor"
                  [isInvalid]="grupo.nome.status?.invalid"
                  [AgStatus]="grupo.nome.status"
                  [id]="'grupo_nome'"
                  AgPlaceholder="{{grupo.nome.placeholder}}"
                  AgInputType="{{grupo.nome.inputType}}"
                  AgMaxlength="{{grupo.nome.maxlength}}"
                  AgInputMode="{{grupo.nome.inputMode}}"
                  (ngModelChange)="grupo.mascara(grupo.nome.mascara, 'nome');"
                  (change)="grupo.validarInput('nome');"
                  >
                </app-ag-input-field>
              </div>
            </div>

            <!-- grupo.descricao -->
            <div class="col-lg-12 reset-padding-mobile">
              <div style="display: flex;flex-direction: row;align-items: center;flex-wrap: nowrap;justify-content: space-between;margin-top: 5px;">
                <app-ag-textarea-field class="w-100"
                  [(ngModel)]="grupo.descricao.valor"
                  [label]="grupo.descricao.title"
                  [tooltip]="grupo.descricao.info"
                  [value]="grupo.descricao.valor"
                  [isInvalid]="grupo.descricao.status?.invalid"
                  [AgStatus]="grupo.descricao.status"
                  [id]="'grupo_descricao'"
                  AgPlaceholder="{{grupo.descricao.placeholder}}"
                  AgInputType="{{grupo.descricao.inputType}}"
                  AgMaxlength="{{grupo.descricao.maxlength}}"
                  AgInputMode="{{grupo.descricao.inputMode}}"
                  (ngModelChange)="grupo.mascara(grupo.descricao.mascara, 'descricao');"
                  (change)="grupo.validarInput('descricao');"
                  >
                </app-ag-textarea-field>
              </div>
            </div>

            <!-- grupo.status -->
            <div class="col-lg-12 reset-padding-mobile">
              <app-ag-mat-checkbox
                [(ngModel)]="grupo.status.valor"
                [label]="grupo.status.title"
                [tooltip]="grupo.status.info"
                [value]="grupo.status.valor"
                [id]="'grupo_status'"
                >
              </app-ag-mat-checkbox>
            </div>

          </div>
        </div>
      </div>

      <!-- GrupoUsuario -->
      <div class="row p-0 m-0">
        <div class="row p-0 m-0">
          <div class="min-width col-lg mb-3">
            <div class="box-gen-card">
              <div class="row p-0 m-0">
                <div class="col-lg-12 reset-padding-mobile">
                  <h3 class="p-0 m-0 text-cor-padrao text-start w-100 mt-2 mb-2">
                    Recursos Disponíveis
                  </h3>
                </div>

                <div class="col-lg-12 reset-padding-mobile">

                  <!-- <h3 class="p-0 m-0 text-cor-padrao text-start w-100 ag-pl-10">Recursos Disponíveis</h3> -->
                  <mat-selection-list #resources>
                    <mat-list-option *ngFor="let rec of recursos" [value]="rec" class="p-0 m-0" style="border-top: var(--border-padrao)">
                      {{rec.nome.valor}} - <span style=" font-size: 13px; font-style: italic; ">{{rec.descricao.valor}}</span>
                      <!-- <div style="display: flex;flex-direction: column;flex-wrap: wrap;align-items: flex-start;justify-content: center;">
                        <span>{{rec.descricao.valor}}</span>
                      </div> -->
                    </mat-list-option>
                  </mat-selection-list>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ação Criar / Cancelar -->
      <div class="min-width col-lg-12 pb-3">
        <div class="p-0 m-0 box-gen-card" style=" background: transparent; box-shadow: none; border: none; ">

          <!-- <div class="w-100 mb-3" style="text-align: left; display: flex; align-items: center; ">
            <mat-checkbox [(ngModel)]="agenda.status.valor" [color]="'radial-primary'">
              {{agenda.status.title}}
            </mat-checkbox>
            <span mat-raised-button #status="matTooltip" [matTooltip]="agenda.status.info" matTooltipPosition="right" (click)="status.show()" class="tooltip-input-icon">
              <i class="bi bi-info-circle-fill"></i>
            </span>
          </div> -->

          <div class="mt-2 d-flex justify-content-between align-items-center flex-nowrap">
            <button type="button" class="btn btn-primary w-50" style="color: #fff;margin-right: 5px;padding: 15px !important;" (click)="salvarGrupo()">Salvar Grupo</button>
            <button type="button" class="btn btn-outline-danger w-50" (click)="routerLink('grupos-usuarios')" style="padding: 15px !important;">Cancelar</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>

<!-- alert Grupo Modal -->
<div class="modal" id="alertGrupoModal" #alertGrupoModal data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title p-0 m-0">Atenção</h4>
        <span id="btn-close-x-foto" class="text-cor-padrao" data-bs-dismiss="modal" style="padding: 0px 0px;font-size: 20px;cursor: pointer;">
          <i class="bi bi-x-circle-fill" style="cursor: pointer;"></i>
        </span>
      </div>

      <!-- Modal body -->
      <div class="modal-body p-0 m-0" >
        <div style="padding: 0px 15px;">
          <h4 class="modal-title pt-3 pb-2 p-0 m-0 text-start">Alguns campos precisam ser preenchidos</h4>
        </div>

        <div style=" padding: 15px; ">

          <div *ngIf="grupo.nome.status?.invalid" class="border-danger gen-card">
            <p class="text-cor-padrao gen-card-title">{{ grupo.nome.title }}</p>
            <p class="text-cor-padrao gen-card-info">{{ grupo.nome.info }}</p>
          </div>

          <div *ngIf="grupo.descricao.status?.invalid" class="border-danger gen-card">
            <p class="text-cor-padrao gen-card-title">{{ grupo.descricao.title }}</p>
            <p class="text-cor-padrao gen-card-info">{{ grupo.descricao.info }}</p>
          </div>

        </div>

      </div>

      <!-- Modal footer -->
      <div class="modal-footer d-flex justify-content-end align-items-start">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
        <!-- <button type="button" class="btn btn-danger"  style="color: #fff;">Deletar</button> -->
      </div>

    </div>
  </div>
</div>
